import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PDFModal from '../components/PDFModal';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [pdfModal, setPdfModal] = useState(null);
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=\u00a1Hola!`;

  const representaciones = [
    {
      id: 1,
      title: 'TECNAL',
      logoText: 'TNL TECNAL',
      logoColor: '#E8A020',
      description: 'Equipos para plantas aceiteras, bioetanol, alimento balanceado, almacenamiento de granos y movimiento portuario.',
      image: '/assets/tecnal/tecnal_header.webp',
      link: '/tecnal'
    },
    {
      id: 2,
      title: 'KSB',
      logoText: 'b KSB',
      logoColor: '#ffffff',
      description: 'Líder mundial en bombas, válvulas y sistemas de control para agua, industria y energía.',
      image: '/assets/ksb/ksb_header.webp',
      link: '/ksb'
    }
  ];

  const productosKSB = [
    {
      id: 1,
      title: 'Bombas centrífugas y de proceso',
      description: 'Equipos para impulsión, transporte y manejo de fluidos industriales con máxima fiabilidad y eficiencia energética.',
      image: '/assets/ksb/aguas-efluentes/328bd827-3308-4ede-b246-daabb5d7e1f4.jpg',
      link: '/ksb/bombas'
    },
    {
      id: 2,
      title: 'Válvulas industriales',
      description: 'Control seguro y eficiente para líneas de producción y sistemas de alta presión.',
      image: '/assets/ksb/valvulas/IMG_2580.jpg',
      link: '/ksb/valvulas'
    },
    {
      id: 3,
      title: 'Sistemas de presurización (Hyamat)',
      description: 'Soluciones automáticas para mantener presión constante en redes de distribución de agua.',
      image: '/assets/ksb/presurizacion/IMG_3503.jpg',
      link: '/assets/ksb/KSB Hyamat - Sistemas de Presurización.pdf',
      isPdf: true
    },
    {
      id: 4,
      title: 'Monitoreo inteligente (KSB Guard)',
      description: 'Sensores conectados para vigilar bombas en tiempo real y prevenir fallas.',
      svgType: 'monitor',
      link: '/assets/ksb/KSB Guard - Monitoreo.pdf',
      isPdf: true
    }
  ];

  const equiposTecnal = [
    {
      id: 1,
      title: 'Crackers',
      description: 'Quebradora de granos oleaginosos. Hasta 1.500 TPD, 4 a 8 rodillos acanalados.',
      image: '/assets/tecnal/crackers_cover.jpg',
      pdf: '/assets/tecnal/pdfs/TECNAL_CRACKER-online.pdf'
    },
    {
      id: 2,
      title: 'Expanders',
      description: 'El expander más grande del mundo. Hasta 4.000 TPD en base soja.',
      image: '/assets/tecnal/expanders_cover.jpg',
      pdf: '/assets/tecnal/pdfs/TECNAL_EXPANDER-online.pdf'
    },
    {
      id: 3,
      title: 'Flakers',
      description: 'Laminador de semillas oleaginosas. Capacidad de 200 a 500 T/24h.',
      image: '/assets/tecnal/flakers_cover.jpg',
      pdf: '/assets/tecnal/pdfs/TECNAL_FLAKERS_online.pdf'
    },
    {
      id: 4,
      title: 'Extractor rotativo',
      description: 'Extractor de aceite por celdas rotativas de fondo fijo. Alta eficiencia y bajo consumo.',
      image: '/assets/tecnal/extractor_cover.jpg',
      pdf: '/assets/tecnal/pdfs/TECNAL_Extrator-DT-online.pdf'
    }
  ];

  const CatalogSvg = () => (
    <svg width="100%" height="160" viewBox="0 0 400 160" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <rect width="400" height="160" fill="#1A3A5C" />
      <text x="320" y="140" fontSize="72" fontWeight="700" fill="rgba(255,255,255,0.04)" textAnchor="middle">KSB</text>
      {/* Document icon */}
      <rect x="160" y="28" width="80" height="104" rx="4" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <polygon points="220,28 240,48 220,48" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <line x1="240" y1="48" x2="240" y2="132" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <rect x="160" y="28" width="60" height="20" rx="4" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      {/* Text lines */}
      <line x1="174" y1="64" x2="226" y2="64" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeLinecap="round" />
      <line x1="174" y1="76" x2="218" y2="76" stroke="rgba(255,255,255,0.13)" strokeWidth="2" strokeLinecap="round" />
      <line x1="174" y1="88" x2="224" y2="88" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeLinecap="round" />
      <line x1="174" y1="100" x2="210" y2="100" stroke="rgba(255,255,255,0.13)" strokeWidth="2" strokeLinecap="round" />
      <line x1="174" y1="112" x2="222" y2="112" stroke="rgba(255,255,255,0.18)" strokeWidth="2" strokeLinecap="round" />
      <line x1="174" y1="124" x2="214" y2="124" stroke="rgba(255,255,255,0.1)" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  const MonitorSvg = () => (
    <svg width="100%" height="160" viewBox="0 0 400 160" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <rect width="400" height="160" fill="#1A3A5C" />
      {/* Radar circles */}
      <circle cx="200" cy="80" r="60" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
      <circle cx="200" cy="80" r="45" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
      <circle cx="200" cy="80" r="30" fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="1" />
      <circle cx="200" cy="80" r="15" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="1" />
      <circle cx="200" cy="80" r="3" fill="rgba(255,255,255,0.3)" />
      {/* Signal lines */}
      <path d="M170 55 Q 160 40, 145 38" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M163 48 Q 155 36, 142 34" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M230 105 Q 240 120, 255 122" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M237 112 Q 245 124, 258 126" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Network nodes */}
      <circle cx="145" cy="50" r="3" fill="rgba(255,255,255,0.25)" />
      <circle cx="260" cy="110" r="3" fill="rgba(255,255,255,0.25)" />
      <circle cx="240" cy="45" r="2.5" fill="rgba(255,255,255,0.2)" />
      <circle cx="155" cy="115" r="2.5" fill="rgba(255,255,255,0.2)" />
      <circle cx="120" cy="85" r="2" fill="rgba(255,255,255,0.15)" />
      <circle cx="280" cy="75" r="2" fill="rgba(255,255,255,0.15)" />
      {/* Connecting lines */}
      <line x1="145" y1="50" x2="185" y2="68" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
      <line x1="260" y1="110" x2="218" y2="93" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
      <line x1="240" y1="45" x2="212" y2="66" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
      <line x1="155" y1="115" x2="187" y2="93" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
      <line x1="120" y1="85" x2="170" y2="80" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
      <line x1="280" y1="75" x2="230" y2="80" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
    </svg>
  );

  const scrollToRepresentaciones = () => {
    const element = document.getElementById('representaciones-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <svg className="hero-bg-svg" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          <rect width="1440" height="900" fill="#001E2B" />

          {/* Dot grid */}
          <pattern id="dotGrid" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="20" r="1" fill="rgba(255,255,255,0.07)" />
          </pattern>
          <rect width="1440" height="900" fill="url(#dotGrid)" />

          {/* Diagonal lines — left */}
          <line x1="0" y1="300" x2="300" y2="0" stroke="rgba(21,101,192,0.06)" strokeWidth="1" />
          <line x1="0" y1="450" x2="450" y2="0" stroke="rgba(21,101,192,0.04)" strokeWidth="1" />
          <line x1="0" y1="600" x2="600" y2="0" stroke="rgba(21,101,192,0.03)" strokeWidth="1" />

          {/* Diagonal lines — right */}
          <line x1="1440" y1="300" x2="1140" y2="0" stroke="rgba(21,101,192,0.06)" strokeWidth="1" />
          <line x1="1440" y1="500" x2="1040" y2="0" stroke="rgba(21,101,192,0.04)" strokeWidth="1" />
          <line x1="1440" y1="700" x2="940" y2="0" stroke="rgba(21,101,192,0.03)" strokeWidth="1" />

          {/* Concentric circles — bottom left */}
          <circle cx="120" cy="780" r="180" fill="none" stroke="rgba(21,101,192,0.06)" strokeWidth="1" />
          <circle cx="120" cy="780" r="130" fill="none" stroke="rgba(21,101,192,0.05)" strokeWidth="1" />
          <circle cx="120" cy="780" r="80" fill="none" stroke="rgba(21,101,192,0.04)" strokeWidth="1" />
          <circle cx="120" cy="780" r="35" fill="none" stroke="rgba(21,101,192,0.03)" strokeWidth="1" />

          {/* Concentric circles — top right */}
          <circle cx="1320" cy="120" r="160" fill="none" stroke="rgba(21,101,192,0.06)" strokeWidth="1" />
          <circle cx="1320" cy="120" r="110" fill="none" stroke="rgba(21,101,192,0.05)" strokeWidth="1" />
          <circle cx="1320" cy="120" r="65" fill="none" stroke="rgba(21,101,192,0.04)" strokeWidth="1" />
          <circle cx="1320" cy="120" r="25" fill="none" stroke="rgba(21,101,192,0.03)" strokeWidth="1" />

          {/* Accent bars — left */}
          <rect x="60" y="200" width="3" height="24" rx="1.5" fill="rgba(21,101,192,0.1)" />
          <rect x="60" y="240" width="3" height="16" rx="1.5" fill="rgba(21,101,192,0.07)" />
          <rect x="60" y="270" width="3" height="32" rx="1.5" fill="rgba(21,101,192,0.09)" />

          {/* Accent bars — right */}
          <rect x="1377" y="500" width="3" height="28" rx="1.5" fill="rgba(21,101,192,0.1)" />
          <rect x="1377" y="544" width="3" height="18" rx="1.5" fill="rgba(21,101,192,0.07)" />
          <rect x="1377" y="576" width="3" height="36" rx="1.5" fill="rgba(21,101,192,0.09)" />

          {/* Central overlay for text readability */}
          <rect x="220" y="150" width="1000" height="600" rx="400" fill="rgba(0,30,43,0.4)" />
        </svg>
        <div className="hero-content">
          <p className="hero-eyebrow">Excelencia aplicada a la ingeniería</p>
          <h1 className="hero-title">
            35 años impulsando el desarrollo industrial
          </h1>
          <p className="hero-description">
            Representamos a marcas líderes internacionales en tecnología industrial,
            ofreciendo soluciones confiables y eficientes para cada sector productivo.
          </p>
          <Button
            size="lg"
            className="hero-cta"
            onClick={scrollToRepresentaciones}
          >
            <ArrowRight className="mr-2" size={20} />
            Ver Representaciones
          </Button>
        </div>
      </section>

      {/* Representaciones Section */}
      <section id="representaciones-section" className="representaciones-section">
        <div className="container">
          <h2 className="section-title">Nuestras Representaciones</h2>

          <div className="representaciones-grid">
            {representaciones.map((rep) => (
              <div key={rep.id} className="rep-card" onClick={() => navigate(rep.link)}>
                <img src={rep.image} alt={rep.title} loading="lazy" className="rep-card__bg" />
                <div className="rep-card__overlay" />
                <div className="rep-card__logo-badge">
                  <span style={{ color: rep.logoColor, fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.02em' }}>
                    {rep.logoText}
                  </span>
                </div>
                <div className="rep-card__content">
                  <h3 className="rep-card__title">{rep.title}</h3>
                  <p className="rep-card__desc">{rep.description}</p>
                  <span className="rep-card__btn">Ver productos →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Productos KSB Section */}
      <section className="productos-ksb-section">
        <div className="container">
          <p className="section-eyebrow">Productos de KSB</p>

          <div className="home-cards-grid">
            {productosKSB.map((producto) => (
              <div
                key={producto.id}
                className="home-card home-card--ksb"
                onClick={() => producto.isPdf ? setPdfModal({ url: producto.link, title: producto.title }) : navigate(producto.link)}
              >
                <div className="home-card__image">
                  {producto.svgType === 'catalog' ? (
                    <CatalogSvg />
                  ) : producto.svgType === 'monitor' ? (
                    <MonitorSvg />
                  ) : (
                    <>
                      <img src={producto.image} alt={producto.title} loading="lazy" />
                      <div className="home-card__gradient" />
                    </>
                  )}
                </div>
                <div className="home-card__body">
                  <h3 className="home-card__title">{producto.title}</h3>
                  <p className="home-card__desc">{producto.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="section-cta">
            <p className="section-cta-text">
              Soluciones confiables para infraestructura, energía e industria.
            </p>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/ksb')}
            >
              Ver todos los productos de KSB
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </div>
        </div>
      </section>

      {/* Equipos TECNAL Section */}
      <section className="equipos-tecnal-section">
        <div className="container">
          <p className="section-eyebrow">Equipos destacados de TECNAL</p>

          <div className="home-cards-grid">
            {equiposTecnal.map((equipo) => (
              <div
                key={equipo.id}
                className="home-card home-card--tecnal"
                onClick={() => setPdfModal({ url: equipo.pdf, title: equipo.title })}
              >
                <div className="home-card__image">
                  <img src={equipo.image} alt={equipo.title} loading="lazy" />
                  <div className="home-card__gradient home-card__gradient--tecnal" />
                </div>
                <div className="home-card__body">
                  <h3 className="home-card__title">{equipo.title}</h3>
                  <p className="home-card__desc">{equipo.description}</p>
                  <span className="home-card__pdf-btn">
                    <Download size={14} />
                    Ver catálogo PDF
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="section-cta">
            <p className="section-cta-text">
              Innovación y tecnología al servicio del desarrollo agroindustrial.
            </p>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/tecnal')}
            >
              Ver todos los productos de TECNAL
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </div>
        </div>
      </section>

      {/* Sobre Nosotros Section */}
      <section className="sobre-nosotros-section">
        <div className="container">
          <h2 className="section-title">Sobre Nosotros</h2>
          <p className="section-subtitle">
            Desde 1991, acompañamos el crecimiento de la industria en Argentina.
          </p>
          <p className="section-text">
            Trabajamos como nexo entre los fabricantes líderes y las empresas industriales de la región, 
            ofreciendo equipos confiables y soporte especializado para plantas productivas de distintos sectores.
            <br /><br />
            Nuestra misión es acercar a las industrias locales la tecnología y calidad de marcas internacionales 
            consolidadas, contribuyendo a mejorar sus procesos y su eficiencia operativa.
          </p>
          <Button 
            size="lg" 
            className="section-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>

      {/* Clientes Section */}
      <section className="clientes-section">
        <div className="container">
          <h2 className="section-title">Nuestros Clientes</h2>
          <p className="section-text">
            <strong>Más de 200 empresas</strong> nos eligen por nuestra trayectoria, 
            compromiso y la calidad de nuestras soluciones.
          </p>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => navigate('/clientes')}
          >
            Ver todos nuestros clientes
            <ArrowRight className="ml-2" size={18} />
          </Button>
        </div>
      </section>
    </div>

    {pdfModal && (
      <PDFModal
        pdfUrl={pdfModal.url}
        title={pdfModal.title}
        onClose={() => setPdfModal(null)}
      />
    )}
    </>
  );
};

export default Home;